module.exports = __webpack_public_path__ + "051444a2cfec4cfd08afb61257845305.png";